import React from 'react';
import { Twitter, Github, Linkedin } from 'lucide-react';
import { PossibleLogo } from '../ui/PossibleLogo';
const links = {
  Product: ['Overview', 'Features', 'Pricing', 'Changelog', 'Roadmap'],
  Company: ['About', 'Blog', 'Careers', 'Press', 'Contact'],
  Resources: ['Documentation', 'Help Center', 'API Reference', 'Community', 'Status'],
  Legal: ['Privacy Policy', 'Terms of Service', 'Cookie Policy', 'Security']
};
export function Footer() {
  return <footer className="bg-gray-900 text-gray-400 py-16" data-id="element-809">
      <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-810">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-12" data-id="element-811">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1" data-id="element-812">
            <div className="flex items-center gap-2 mb-3" data-id="element-813">
              <PossibleLogo height={16} variant="white" data-id="element-814" />
            </div>
            <p className="text-xs text-gray-500 leading-relaxed mb-4" data-id="element-815">
              AI-powered personal finance management for everyone.
            </p>
            <div className="flex gap-3" data-id="element-816">
              {[Twitter, Github, Linkedin].map((Icon, i) => <button key={i} className="w-8 h-8 rounded-lg bg-gray-800 hover:bg-gray-700 flex items-center justify-center transition-colors" data-id="element-817">
                  <Icon size={14} data-id="element-818" />
                </button>)}
            </div>
          </div>

          {/* Links */}
          {Object.entries(links).map(([category, items]) => <div key={category} data-id="element-819">
              <p className="text-white text-xs font-semibold uppercase tracking-widest mb-3" data-id="element-820">
                {category}
              </p>
              <ul className="space-y-2" data-id="element-821">
                {items.map(item => <li key={item} data-id="element-822">
                    <button className="text-xs text-gray-500 hover:text-gray-300 transition-colors" data-id="element-823">
                      {item}
                    </button>
                  </li>)}
              </ul>
            </div>)}
        </div>

        <div className="border-t border-gray-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-824">
          <p className="text-xs text-gray-600" data-id="element-825">
            © 2026 Possible, Inc. All rights reserved.
          </p>
          <p className="text-xs text-gray-600" data-id="element-826">
            Made with ❤️ for better financial futures
          </p>
        </div>
      </div>
    </footer>;
}